<template>
  <div class="content line_height">
    <div  class="w-e-text" v-html="data"></div>
  </div>
</template>

<script>
import http from '@/utils/axios'
export default {
  data() {
    return {
      platform: this.$route.query.platform,
      data: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let url = this.platform == 'user' ? 'sys/admin/sys_var/findUserThirdSdkCatalog' : 'sys/admin/sys_var/findBeesThirdSdkCatalog'
      http({
        url: url,
        method: 'get',
        parmes: {},
        headers:{
          'tenant_code':'75c8dm'
        }
      }).then(res => {
        if (res.code == 200) {
          this.data = res.data
          this.$loading.hide();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 30px 30px 30px;
   /deep/.w-e-text {
    padding: 0 10px;
    overflow-y: scroll;
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        th {
            border-bottom: 2px solid #ccc;
            text-align: center;
        }
        td, th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 3px 5px;
        }
      }
      p,  h1,  h2,  h3,  h4,  h5,  table,   pre {
        margin: 10px 0;
        line-height: 1.5;
      }
      blockquote {
          display: block;
          border-left: 8px solid #d0e5f2;
          padding: 5px 10px;
          margin: 10px 0;
          line-height: 1.4;
          font-size: 100%;
          background-color: #f1f1f1;
      }
      img {
          cursor: pointer;
      }
  }
}
</style>